module.exports = require('./DepGenericSubmissionFilingView');
